module.exports = require('./DepGenericSubmissionFilingView');
